import comp from "./ResponseItem";
export default comp;
